var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#00c851;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1437 -171)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1437 171)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1423.933 174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.067 5.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.853,153.6H28.638a.643.643,0,0,0,0,1.286h3.214a.643.643,0,0,1,.643.643v8.357a.643.643,0,0,1-.643.643H19a.643.643,0,0,1-.643-.643v-8.357a.643.643,0,0,1,.643-.643H22.21a.643.643,0,1,0,0-1.286H19a1.929,1.929,0,0,0-1.929,1.929v8.357A1.929,1.929,0,0,0,19,165.814H31.853a1.929,1.929,0,0,0,1.929-1.929v-8.357A1.929,1.929,0,0,0,31.853,153.6Z",
    transform: "translate(-17.067 -153.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.245,9.188a.643.643,0,0,0-.893,0l-2.118,2.117V.643a.643.643,0,1,0-1.286,0V11.305l-2.117-2.117a.643.643,0,0,0-.909.909l3.214,3.214a.643.643,0,0,0,.909,0h0l3.214-3.214A.643.643,0,0,0,144.245,9.188Z",
    transform: "translate(-136.742)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b02ad460c0b07d1d61b8801ee623f94d.svg";
export { ForwardRef as ReactComponent };